import graphqlClient from "../../../apollo";

class AfipOrderProvider {


    createOrderReceipt(orderId) {
        return graphqlClient.mutate({
            mutation: require('./gql/AfipOrder/createOrderReceipt.graphql'),
            variables: {orderId}
        })
    }



}

export default new AfipOrderProvider()


